import application from 'application/application';

import 'select2';

application.directive('ngCustomSelectLazyLoadParams', [
	'$timeout',
	'API',
	'environment',
	($timeout, API, environment) => ({
		restrict: 'A',
		require: 'ngModel',
		scope: {
			extraParams: '=?',
			onSelect: '&?'
		},

		link(scope, element, attributes, ngModelCtrl) {
			let getCustomUrl = API[attributes.paths].paths[attributes.customUrl];

			let url = `https://dev-api.advise.com.br/core/v1/${getCustomUrl}`;

			if (environment.name === 'homologation')
				url = `https://homologacao-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (API.default.hostname.includes('sandbox-'))
				url = `https://sandbox-api.advise.com.br/core/v1/${getCustomUrl}`;
			else if (environment.name === 'production')
				url = `https://api.advise.com.br/core/v1/${getCustomUrl}`;

			const headers = localStorage.getItem('__authenticationToken__')
				? {
						Authorization:
							'Bearer ' + localStorage.getItem('__authenticationToken__')
				  }
				: {};

			const customSearch = attributes.ngCustomRegex
				? eval(`(${attributes.ngCustomRegex})`)
				: false;

			$(element)
				.select2({
					width: '100%',
					placeholder: attributes.placeholder,
					...(attributes.noResultsText
						? {
								language: {
									noResults: () => attributes.noResultsText
								}
						  }
						: {}),
					minimumInputLength: Number(attributes.minimumLengthToSearch || 0),
					maximumInputLength: attributes.maximumLengthToSearch,
					dropdownParent:
						'ngSelectRelativeElement' in attributes
							? $(element).closest(
									attributes.ngSelectRelativeElement
										? attributes.ngSelectRelativeElement
										: 'body'
							  )
							: $(element).closest('.modal').length
							? $(element).closest('form')
							: '',
					containerCssClass: attributes.customSelectClass,
					dropdownCssClass: attributes.customDropClass,
					ajax: {
						delay: 250,
						url: url,
						headers: headers,
						data(params) {
							const term = params.term == null ? '' : params.term;

							const object = {
								registrosPorPagina: 10,
								...scope.extraParams,
								paginaAtual: params.page || 1
							};

							if (term) {
								object[
									attributes.ngSelectParam || 'nomePalavraChave'
								] = customSearch ? customSearch(term) : term;
							}

							if (attributes.ngSelectActive)
								object['ativo'] = attributes.ngSelectActive;

							if (attributes.ngFields) object['Campos'] = attributes.ngFields;

							if (attributes.ngGroupId)
								object['IdGrupo'] = attributes.ngGroupId;

							if (attributes.ngGroupUserId)
								object['IdGrupoUsuarios'] = attributes.ngGroupUserId;

							if (attributes.ngTipoPasta)
								object['idTipoPasta'] = attributes.ngTipoPasta;

							return object;
						},
						processResults(data) {
							if (data.itens) {
								scope.resultsData = data.itens;

								return {
									results: scope.resultsData.map(item => {
										const realId = attributes.ngCustomValue
											? item[attributes.ngCustomValue]
											: item.idPalavraChave || item.id;

										const label = attributes.ngCustomLabel
											? item[attributes.ngCustomLabel]
											: item.nomePasta || item.nome;

										return {
											id: label,
											text: label,
											value: realId,
											originalItem: item
										};
									}),
									pagination: {
										more: data.itens.length === 10
									}
								};
							}
						}
					},
					templateResult: item => {
						return attributes.customElementClass !== undefined
							? customizeElement(item, attributes.customElementClass)
							: item.text;
					},
					templateSelection: item => {
						return attributes.customElementClass !== undefined
							? customizeElement(item, attributes.customElementClass)
							: item.text;
					},
					theme: attributes.customSelectTheme
				})
				.on('select2:open', () => {
					$('.select2-results__options').on('mousedown', e => {
						if (e.button == 1) return false;
					});
				})
				.on('select2:select', event =>
					$timeout(() => {
						if (!$(element).data('select2') || $(element).prop('disabled')) {
							return;
						}

						const selectedData = event.params.data;
						const selectedItem = selectedData.originalItem || {};

						const selectedText = selectedData.text;

						const selectedId =
							selectedData.value ||
							selectedItem[attributes.ngCustomValue] ||
							selectedItem.id ||
							null;

						$(element).attr('ng-custom-model', selectedText);
						$(element).attr('ng-process-value', selectedId);

						const optionExists =
							$(element)
								.find('option')
								.filter(
									(_, option) => String(option.value) === String(selectedText)
								).length > 0;

						if (!optionExists) {
							const option = new Option(selectedText, selectedText, true, true);

							$(element).append(option);
						}

						$(element)
							.val(selectedText)
							.trigger('change.select2');

						removeSelectionTitle(element);

						ngModelCtrl.$setViewValue(selectedText);

						if (scope.onSelect) {
							scope.onSelect({
								item: selectedData.originalItem || null,
								selection: selectedData
							});
						}
					})
				)
				.on('select2:opening', () =>
					$(window).on('resize.select2', () => $(element).select2('close'))
				)

				// Desatch resize event on close
				.on('select2:closing', () => $(window).off('resize.select2'));

			// Remover o title inicial.
			removeSelectionTitle(element);

			// Remover o title após alterações da seleção.
			$(element).on('change.removeSelectionTitle', () => {
				removeSelectionTitle(element);
			});

			let syncPromise = null;

			scope.$watch(
				() => ngModelCtrl.$viewValue,
				() => {
					if (syncPromise) {
						$timeout.cancel(syncPromise);
					}

					syncPromise = $timeout(
						() => {
							syncPromise = null;

							const $select = $(element);

							if (!$select.data('select2')) {
								return;
							}

							const value = ngModelCtrl.$viewValue;

							$select.val(value == null ? '' : value).trigger('change.select2');

							removeSelectionTitle(element);
						},
						0,
						false
					);
				}
			);

			scope.$on('$destroy', () => {
				if (syncPromise) {
					$timeout.cancel(syncPromise);
				}

				const $select = $(element);

				if ($select.data('select2')) {
					$select.select2('close');
					$select.select2('destroy');
				}

				$select.off(
					'select2:open select2:select select2:opening select2:closing'
				);
			});
		}
	})
]);

function customizeElement(el, elClass) {
	if ((el.element && el.element.classList[0]) != undefined) {
		let where = el.element.classList[0].slice(5);
		let span = document.createElement('span');
		let text = document.createTextNode(el.text);

		if (el.text.indexOf(where) > -1) span.classList.add(elClass);

		span.appendChild(text);

		return span;
	} else {
		return el.text;
	}
}

function removeSelectionTitle(element) {
	const select2 = $(element).data('select2');

	if (!select2) return;

	select2.$container.find('.select2-selection__rendered').removeAttr('title');
}
